<template>
  <div class="fixed bottom-10 left-10">
    <el-image
      class="pointer-events-none absolute top-[100px] left-1/2 -translate-x-1/2"
      src="football.png"
    ></el-image>
    <div
      class="left-[10px] flex w-[200px] flex-col items-center overflow-visible rounded-2xl bg-white p-3 dark:bg-[#19231E]"
    >
      <div
        class="mt-12 mb-3 px-1 text-center text-xs leading-tight dark:text-white"
      >
        使用手机扫二维码下载叭球APP与主播一起分析前沿赛事，掌上高清投屏，邀请下载领福利，快扫码下载吧～
      </div>
      <el-image class="mb-1 size-[120px]" src="/common/qrcode.png" />
      <div class="text-center text-xs dark:text-white">扫码下载App</div>
    </div>
  </div>
</template>

<script setup>
// 下载二维码卡片组件
</script>

<style scoped>
/* 组件样式 */
</style>
